import { render, staticRenderFns } from "./dev-details.vue?vue&type=template&id=639fccee"
import script from "./dev-details.vue?vue&type=script&lang=ts"
export * from "./dev-details.vue?vue&type=script&lang=ts"
import style0 from "./dev-details.vue?vue&type=style&index=0&id=639fccee&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports